<template>
  <v-chip
    :color="isNew ? 'success' : 'grey-darken-1'"
    size="x-small"
    variant="flat"
    label
    class="encryption-gen-badge ml-2 font-weight-bold flex-shrink-0"
    :title="tooltip"
  >{{ isNew ? 'NEW!' : 'LEGACY' }}</v-chip>
</template>

<script>
  // Tiny "which encryption is this?" marker. Two end-to-end encryption
  // generations coexist in the webapp — the original Virgil passcode scheme
  // ("Legacy Encryption (E2EE)") and the libsodium NC1 passkey scheme ("End-to-End
  // Encryption NEW!") — and both panels sit on the same Account page. Every
  // legacy-only surface carries generation="legacy", every NC1-only surface
  // generation="new", so customers can tell at a glance which one a heading,
  // dialog, or button refers to. Registered globally in main.js.
  export default {
    name: 'EncryptionGenBadge',
    props: {
      generation: {
        type: String,
        required: true,
        validator: value => ['new', 'legacy'].includes(value)
      }
    },
    computed: {
      isNew() {
        return this.generation === 'new'
      },
      tooltip() {
        return this.isNew
          ? 'The new end-to-end encryption: unlocked with a passkey or recovery code'
          : 'The original end-to-end encryption (E2EE): unlocked with a shared passcode'
      }
    }
  }
</script>

<style scoped>
  .encryption-gen-badge {
    letter-spacing: 0.5px;
    vertical-align: middle;
  }
</style>
